export const dynamicRoutes = []
